const homeSlides = [
  {
    image: `${process.env.PUBLIC_URL}/images/GameNight.jpg`,
    title: "Monthly YSA Meeting",
    description: "Join us every 3rd Saturday from 7-9PM for games, food, and fun!",
  },
  {
    image: `${process.env.PUBLIC_URL}/images/StudyGroup.jpg`,
    title: "Temple Trip",
    description: "Every Wednesday at 8:30 PM, online via Zoom. meeting ID: 712 5869 3385, passcode: 3lbYsb",
  },
  {
    image: `${process.env.PUBLIC_URL}/images/TempleDay.jpg`,
    title: "Service Project",
    description: "Baptisms 1-3PM, Endowment 2-2:30PM.",
  },
  {
    image: `${process.env.PUBLIC_URL}/images/Caroling.png`,
    title: "Monthly YSA Meeting",
    description: "Taken over for the 20th of Dec activity. Carpool to local nursing homes to sing Christmas carols.",
  }
];

export default homeSlides;
